export const EmbeddedCapacityDescription = () => (
  <div className="flex flex-col gap-y-4">
    <div>
      The Embedded Capacity Register shows the distribution of energy generation connected to the DNO network across the
      country. Both connected generation and projects that have been accepted to connect to the network are represented.
    </div>
  </div>
);
